import useSEO from "@/hooks/useSEO";
import LegalLayout from "./LegalLayout";
import { COMPANY } from "@/config/site";

export default function CGV() {
  useSEO({
    title: "Conditions générales de vente",
    description:
      "Conditions générales du service de mise en relation proposé par PENOW à Fondettes (37230). Rôle d'apporteur d'affaires, devis via le partenaire, droit de rétractation, garanties légales, responsabilité.",
    path: "/cgv",
  });

  return (
    <LegalLayout
      title="Conditions générales de vente"
      subtitle="Les présentes conditions générales régissent l'utilisation du service de mise en relation proposé par PENOW entre clients (particuliers ou professionnels) et professionnels partenaires du bâtiment."
      updatedAt="Décembre 2025"
    >
      <div className="callout" style={{ background: "#FFF5F0", borderLeftColor: "#C05C3D" }}>
        <strong>Rôle de PENOW — Apporteur d'affaires</strong>
        <br />
        PENOW est un <strong>service de mise en relation</strong> (apporteur
        d'affaires) entre des clients et des professionnels partenaires du
        bâtiment. <strong>PENOW n'exécute aucun travaux</strong>, n'est pas
        constructeur, n'est pas artisan, et ne se substitue pas aux
        professionnels partenaires. Les travaux, devis, garanties (parfait
        achèvement, biennale, décennale) et assurances (RC pro, décennale)
        sont fournis exclusivement par le professionnel partenaire retenu par
        le Client, sous sa seule responsabilité.
      </div>

      <h2>Article 1 — Objet</h2>
      <p>
        Les présentes CGV définissent les conditions dans lesquelles PENOW,
        établie {COMPANY.address}, fournit à ses clients (ci-après « le
        Client ») un <strong>service de mise en relation</strong> avec des
        professionnels du bâtiment partenaires (ci-après « les Partenaires »)
        dans les domaines suivants : rénovation générale de l'habitat,
        climatisation et pompes à chaleur, poêles à granulés, ravalement de
        façade, nettoyage et rénovation de toiture, isolation thermique,
        vidéosurveillance, arrosage automatique, nettoyage d'extérieurs.
      </p>
      <p>
        Toute utilisation du service implique l'acceptation sans réserve des
        présentes CGV par le Client.
      </p>

      <h2>Article 2 — Nature du service PENOW</h2>
      <p>
        Le service fourni par PENOW consiste exclusivement à :
      </p>
      <ul>
        <li>Recevoir la demande du Client via le formulaire de contact ou par téléphone,</li>
        <li>Analyser la demande et l'orienter vers un Partenaire adapté,</li>
        <li>Transmettre la demande au Partenaire identifié,</li>
        <li>Le cas échéant, assurer un suivi commercial de la mise en relation.</li>
      </ul>
      <p>
        <strong>PENOW n'intervient jamais sur les chantiers, ne réalise aucune
        prestation technique, et n'agit pas comme mandataire des Partenaires.</strong>
      </p>

      <h2>Article 3 — Rôle et responsabilité du Partenaire</h2>
      <p>
        Le Partenaire mis en relation avec le Client est seul responsable :
      </p>
      <ul>
        <li>De l'établissement du devis et de la fixation du prix,</li>
        <li>De la souscription des assurances obligatoires (RC pro, décennale, biennale, parfait achèvement),</li>
        <li>Des qualifications professionnelles requises (RGE, Qualibat, Qualifelec, Consuel…),</li>
        <li>De la réalisation matérielle des travaux, du respect des délais et de la qualité de l'exécution,</li>
        <li>De la mobilisation des aides publiques éventuelles (MaPrimeRénov', CEE),</li>
        <li>Du service après-vente et de la mise en œuvre des garanties légales.</li>
      </ul>
      <p>
        Le contrat de prestation est conclu <strong>directement entre le Client
        et le Partenaire</strong>, sans que PENOW n'y soit partie.
      </p>

      <h2>Article 4 — Gratuité du service de mise en relation</h2>
      <p>
        Le service de mise en relation est <strong>gratuit</strong> pour le
        Client. PENOW est rémunérée par ses Partenaires au titre de son
        activité d'apporteur d'affaires. Cette rémunération n'a aucune
        incidence sur le prix du devis remis au Client par le Partenaire.
      </p>

      <h2>Article 5 — Devis et acceptation par le Partenaire</h2>
      <p>
        À la suite de la mise en relation, le Partenaire adresse au Client un
        devis écrit, gratuit et sans engagement, précisant la nature détaillée
        des travaux, les matériaux, le prix (HT et TTC), les délais et les
        modalités de paiement.
      </p>
      <p>
        Le contrat de prestation est formé entre le Client et le Partenaire à
        réception du devis daté et signé par le Client.
      </p>

      <h2>Article 6 — Modalités de paiement</h2>
      <p>
        Toute somme versée par le Client au titre des travaux est perçue
        exclusivement par le Partenaire, selon les modalités qu'il définit
        dans son devis. <strong>PENOW ne perçoit aucun paiement du Client pour
        les travaux</strong> et n'établit aucune facture de prestation
        technique.
      </p>

      <h2>Article 7 — Droit de rétractation</h2>
      <p>
        Conformément aux articles L. 221-18 et suivants du Code de la
        consommation, le Client particulier qui conclut un contrat hors
        établissement (à son domicile) avec le Partenaire dispose d'un délai
        de <strong>quatorze (14) jours</strong> à compter de la signature du
        contrat pour se rétracter, sans avoir à motiver sa décision.
      </p>
      <p>
        Le droit de rétractation s'exerce auprès du <strong>Partenaire</strong>
        {" "}avec lequel le contrat a été conclu. Un formulaire type de
        rétractation est joint au devis du Partenaire.
      </p>
      <div className="callout">
        <strong>Exception — Travaux urgents</strong> : si le Client demande
        expressément l'exécution des travaux avant la fin du délai de
        rétractation, il perd son droit de rétractation dès la complète
        exécution du contrat (art. L. 221-25 du Code de la consommation).
      </div>

      <h2>Article 8 — Garanties légales</h2>
      <p>
        Les garanties légales (garantie de parfait achèvement, garantie
        biennale de bon fonctionnement, garantie décennale) sont fournies par
        le <strong>Partenaire</strong> qui réalise les travaux, à titre de
        constructeur au sens du Code civil, et couvertes par ses propres
        assurances professionnelles. Une attestation d'assurance est
        transmise par le Partenaire au Client à sa demande.
      </p>
      <p>
        PENOW <strong>n'étant pas partie</strong> au contrat de prestation, ne
        fournit ni ne garantit aucune de ces garanties.
      </p>

      <h2>Article 9 — Limitation de responsabilité de PENOW</h2>
      <p>
        La responsabilité de PENOW est <strong>strictement limitée</strong> à
        son activité de mise en relation. PENOW ne peut en aucun cas être tenue
        responsable :
      </p>
      <ul>
        <li>De la qualité, des délais, du prix ou de la conformité des travaux réalisés par le Partenaire,</li>
        <li>Des dommages matériels ou immatériels causés à l'occasion des travaux,</li>
        <li>Du non-respect par le Partenaire de ses obligations légales, réglementaires ou contractuelles,</li>
        <li>Du non-versement des aides publiques par les organismes payeurs,</li>
        <li>De l'absence, de la caducité ou de l'insuffisance des assurances du Partenaire.</li>
      </ul>
      <p>
        Le Client reconnaît qu'il lui appartient de vérifier, avant tout
        engagement contractuel, les qualifications, les assurances et la
        situation administrative du Partenaire. PENOW peut, sur simple demande,
        transmettre les coordonnées et références de ses Partenaires.
      </p>

      <h2>Article 10 — Sélection des Partenaires</h2>
      <p>
        PENOW sélectionne ses Partenaires selon des critères de qualité :
        qualifications professionnelles, avis clients, expérience, respect des
        obligations légales. Cette sélection ne constitue toutefois pas une
        garantie de résultat et n'engage pas la responsabilité de PENOW quant
        aux prestations exécutées.
      </p>

      <h2>Article 11 — Données personnelles</h2>
      <p>
        Les données personnelles du Client sont traitées conformément à notre{" "}
        <a href="/confidentialite">politique de confidentialité</a>{" "}
        et au Règlement Général sur la Protection des Données (RGPD). Elles
        sont notamment transmises au Partenaire retenu pour lui permettre de
        vous adresser un devis. Le Client peut à tout moment exercer ses
        droits d'accès, de rectification, d'effacement et d'opposition.
      </p>

      <h2>Article 12 — Réclamations et médiation</h2>
      <p>
        Toute réclamation relative aux travaux ou au devis doit être adressée
        directement au <strong>Partenaire</strong> concerné. Toute réclamation
        relative au service de mise en relation peut être adressée à PENOW à
        l'adresse <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
      </p>
      <p>
        En cas de litige et à défaut de résolution amiable, le Client
        consommateur peut recourir gratuitement au médiateur de la
        consommation compétent. Plateforme européenne de règlement en ligne
        des litiges : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">ec.europa.eu/consumers/odr</a>.
      </p>

      <h2>Article 13 — Droit applicable et juridiction</h2>
      <p>
        Les présentes CGV sont soumises au droit français. En cas de litige
        persistant, à défaut de résolution amiable ou par la médiation, les
        tribunaux français seront seuls compétents. Le tribunal du domicile du
        consommateur est compétent lorsque celui-ci est demandeur.
      </p>

      <div className="callout">
        Pour toute question concernant ces CGV, contactez-nous à{" "}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> ou par
        téléphone au <a href={COMPANY.phoneHref}>{COMPANY.phone}</a>.
      </div>
    </LegalLayout>
  );
}
